"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowTypeEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var FlowTypeEnum;
(function (FlowTypeEnum) {
    FlowTypeEnum["SsoIns"] = "SSO-INS";
    FlowTypeEnum["SsoFin"] = "SSO-FIN";
    FlowTypeEnum["WebIns"] = "WEB-INS";
    FlowTypeEnum["WebRsu"] = "WEB-RSU";
    FlowTypeEnum["WebRsp"] = "WEB-RSP";
    FlowTypeEnum["WebUpd"] = "WEB-UPD";
    FlowTypeEnum["Imp"] = "IMP";
    FlowTypeEnum["Exp"] = "EXP";
    FlowTypeEnum["Api"] = "API";
    FlowTypeEnum["WebLgn"] = "WEB-LGN";
    FlowTypeEnum["WebFin"] = "WEB-FIN";
    FlowTypeEnum["Fin"] = "FIN";
})(FlowTypeEnum = exports.FlowTypeEnum || (exports.FlowTypeEnum = {}));
